import React from 'react';
import {useLocation, withRouter} from "react-router";
import queryString from 'query-string'
import * as apiController from "../controllers/apiController";
import {CircularProgress, makeStyles} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    loadingDiv: {
        display: "flex",
        height: "100vh",
        width: "100%",
        alignItems: "center",
        justifyContent: "center"
    }
}));

function Callback({history}) {
    const classes = useStyles();
    const { search } = useLocation()
    const values = queryString.parse(search)

    if(values.error || !values.code) {
        window.location = "/";
        return;
    }

    apiController.getSpotifyToken(values.code);

    return (
        <div className={classes.loadingDiv}>
            <CircularProgress size={140} />
        </div>
    );
}

export default withRouter(Callback);
